import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import useDynamicField from "developer/edit/hooks/useDynamicField";
import { setColumnEdited } from "developer/edit/store/editorSlice";
import React, { useCallback } from "react";
import { useAppDispatch } from "store/hooks";

const PanelBreadcrumb: React.FC<{}> = () => {
  const dispatch = useAppDispatch();

  const {
    input: { value: name },
  } = useDynamicField<string>("element.name", false);

  const handleClickBack = useCallback(() => {
    dispatch(setColumnEdited(null));
  }, [dispatch]);

  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="space-between"
      alignItems="center"
    >
      <Tooltip title={name}>
        <Typography variant="subtitle2" noWrap>
          Table - {name}
        </Typography>
      </Tooltip>
      <Button
        variant="text"
        size="small"
        startIcon={<ArrowBackIosNewIcon fontSize="small" />}
        onClick={handleClickBack}
      >
        Back
      </Button>
    </Stack>
  );
};

export default PanelBreadcrumb;
